/*
  Experiment-Quiz  (assets/modolino-quiz.js)
  Logik für sections/content-quiz.liquid. Liest die Einstellungen aus den
  data-Attributen von #modolino-quiz-root:
    data-src      URL der Quiz-Daten (templates/blog.quiz-daten.liquid)
    data-privacy  Link zur Datenschutzerklärung
    data-email    E-Mail eingeloggter Kunden (für die Newsletter-Anmeldung)
*/
(function() {
  'use strict';

  /* ═══════════════════════════════════════════
     EXPERIMENT-DATEN
     Kommen aus templates/blog.quiz-daten.liquid und werden erst geladen,
     wenn man in die Nähe des Quiz scrollt (oder auf "Los geht's" tippt).
     ═══════════════════════════════════════════ */
  var root = document.getElementById('modolino-quiz-root');
  if (!root) return;
  var EXPERIMENTS = [];
  var dataPromise = null;
  function loadData() {
    if (dataPromise) return dataPromise;
    dataPromise = fetch(root.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(list) { EXPERIMENTS = list; prep(); return list; })
      .catch(function(err) { dataPromise = null; throw err; });
    return dataPromise;
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) { io.disconnect(); loadData().catch(function(){}); }
    }, { rootMargin: '800px 0px' });
    io.observe(root);
  } else {
    loadData().catch(function(){});
  }


  var PRIVACY_URL = root.getAttribute('data-privacy') || '/policies/privacy-policy';

  /* ═══════════════════════════════════════════
     CHARAKTER-KONFIGURATION (17 Charaktere)
     ═══════════════════════════════════════════ */
  var CHAR_CATEGORY = {
    'Lumi':'Licht & Farben','Tock':'Klänge & Geräusche','Volt':'Elektrizität & Magnetismus',
    'Turbo':'Bewegung & Kraft','Flocke':'Wärme & Kälte','Tibo':'Technik & Bauen','Reibo':'Haftung & Reibung',
    'Flux':'Chemie & Materialien','Wirbel':'Luft & Wind','Mila':'Wasser & Flüssigkeiten','Drucki':'Druck & Gase',
    'Lotta':'Mein Körper & Sinne','Flora':'Pflanzen & Tiere','Terra':'Umwelt & Nachhaltigkeit',
    'Numbo':'Zahlen & Logik','Lucki':'Zufall & Wahrscheinlichkeit','Dati':'Daten & Fakten'
  };
  var CHAR_EMOJI = {
    'Lumi':'🔆','Tock':'🔊','Volt':'⚡','Turbo':'🏃',
    'Flocke':'❄️','Tibo':'🏗️','Reibo':'🤝',
    'Flux':'⚗️','Wirbel':'💨','Mila':'💧','Drucki':'🎈',
    'Lotta':'🧍','Flora':'🌿','Terra':'🌍',
    'Numbo':'🔢','Lucki':'🎲','Dati':'📊'
  };
  var CC = {
    'Mila':{a:'#66C3FF',s1:'#D7EFFF',s2:'#ECF8FF'},
    'Drucki':{a:'#66C3FF',s1:'#D7EFFF',s2:'#ECF8FF'},
    'Turbo':{a:'#EB5D67',s1:'#FCCFD1',s2:'#FDEBEC'},
    'Flux':{a:'#81BC46',s1:'#DEEECF',s2:'#F0F7E9'},
    'Wirbel':{a:'#81BC46',s1:'#DEEECF',s2:'#F0F7E9'},
    'Flora':{a:'#F7CA41',s1:'#FDF0C8',s2:'#FEF8E5'},
    'Tock':{a:'#368246',s1:'#C3F2CB',s2:'#E1F8E5'},
    'Terra':{a:'#368246',s1:'#C3F2CB',s2:'#E1F8E5'},
    'Reibo':{a:'#368246',s1:'#C3F2CB',s2:'#E1F8E5'},
    'Lotta':{a:'#D8699C',s1:'#F5D8E5',s2:'#FAEDF3'},
    'Dati':{a:'#6E64A5',s1:'#D9D7E8',s2:'#EDECF4'},
    'Volt':{a:'#EC8440',s1:'#FADFCE',s2:'#FDF0E8'},
    'Tibo':{a:'#EC8440',s1:'#FADFCE',s2:'#FDF0E8'},
    'Lucki':{a:'#0C6291',s1:'#C6DAE5',s2:'#DDE9F0'},
    'Flocke':{a:'#0C6291',s1:'#C6DAE5',s2:'#DDE9F0'},
    'Lumi':{a:'#0C6291',s1:'#C6DAE5',s2:'#DDE9F0'},
    'Numbo':{a:'#66C3FF',s1:'#D7EFFF',s2:'#ECF8FF'}
  };
  var CAT_EMOJI = {};
  Object.keys(CHAR_CATEGORY).forEach(function(k){CAT_EMOJI[CHAR_CATEGORY[k]]=CHAR_EMOJI[k];});

  function prep() {
    EXPERIMENTS.forEach(function(e) {
      e.category = CHAR_CATEGORY[e.charShort] || '';
      e.emoji = CHAR_EMOJI[e.charShort] || '🧪';
    });
    buildCats();
  }

  function gc(n) { return CC[n] || {a:'#EB5D67',s1:'#FCCFD1',s2:'#FDEBEC'}; }

  /* ═══════════════════════════════════════════
     FRAGEN
     ═══════════════════════════════════════════ */
  var QS = [
    {id:'gender',ic:'🧒',t:'Wird ein Junge oder Mädchen experimentieren?',s:'Das hilft uns, passende Empfehlungen zu geben.',nofilter:true,grid:true,opts:[
      {v:'junge',l:'Junge',e:'👦'},
      {v:'maedchen',l:'Mädchen',e:'👧'},
      {v:'beide',l:'Junge & Mädchen',e:'👦👧',full:true}
    ]},
    {id:'age',ic:'🎂',t:'Wie alt ist dein Kind?',s:'So finden wir altersgerechte Experimente.',grid:true,cols4:true,opts:[
      {v:'3',l:'Jahre',e:'3'},
      {v:'4',l:'Jahre',e:'4'},
      {v:'5',l:'Jahre',e:'5'},
      {v:'6',l:'Jahre',e:'6'},
      {v:'7',l:'Jahre',e:'7'},
      {v:'8',l:'Jahre',e:'8'},
      {v:'9',l:'Jahre',e:'9'},
      {v:'10+',l:'Jahre',e:'10+'}
    ]},
    {id:'time',ic:'⏱️',t:'Wie viel Zeit hast du?',s:'Manche Experimente sind blitzschnell, andere brauchen etwas mehr.',grid:true,opts:[
      {v:'15',l:'Bis 15 Minuten',e:'⚡'},
      {v:'30',l:'Bis 30 Minuten',e:'⏱️'},
      {v:'45+',l:'45 Minuten oder mehr',e:'🕰️',full:true}
    ]},
    {id:'diff',ic:'🎯',t:'Wie anspruchsvoll darf es sein?',s:'Für Einsteiger oder schon kleine Profis?',grid:true,opts:[
      {v:'leicht',l:'Leicht',e:'😊'},
      {v:'mittel',l:'Mittel',e:'🤔'},
      {v:'schwer',l:'Schwer',e:'🧠'},
      {v:'any',l:'Egal',e:'🤷'}
    ]},
    {id:'category',ic:'🔭',t:'Welches Thema interessiert dich?',s:'Wähle eine oder mehrere Kategorien.',multi:true,dynamic:true,opts:[]},
    {id:'saison',ic:'🌦️',t:'Für welche Jahreszeit?',s:'Oder einfach ganzjährig?',grid:true,opts:[
      {v:'frühling',l:'Frühling',e:'🌸'},
      {v:'sommer',l:'Sommer',e:'☀️'},
      {v:'herbst',l:'Herbst',e:'🍂'},
      {v:'winter',l:'Winter',e:'❄️'},
      {v:'any',l:'Ganzjährig',e:'📅',full:true}
    ]},
    {id:'source',ic:'📣',t:'Wie bist du auf Modolino aufmerksam geworden?',s:'Das hilft uns, besser zu werden!',nofilter:true,grid:true,opts:[
      {v:'instagram',l:'Instagram',e:'📸'},
      {v:'tiktok',l:'TikTok',e:'🎵'},
      {v:'youtube',l:'YouTube',e:'▶️'},
      {v:'pinterest',l:'Pinterest',e:'📌'},
      {v:'google',l:'Google-Suche',e:'🔍'},
      {v:'freunde',l:'Freunde & Familie',e:'👨‍👩‍👧‍👦'},
      {v:'blog',l:'Blog / Artikel',e:'📝'},
      {v:'sonstiges',l:'Sonstiges',e:'💬'}
    ]}
  ];

  /* Kategorien dynamisch aus vorhandenen Experimenten aufbauen.
     Läuft in prep(), also erst wenn die Daten geladen sind; die Daten enthalten nur
     veröffentlichte Anleitungen, daher erscheint jedes Thema mit mindestens einem Experiment. */
  function buildCats() {
    var seen = {};
    var cats = [];
    EXPERIMENTS.forEach(function(e) {
      if (e.category && !seen[e.category]) {
        seen[e.category] = true;
        cats.push({v:e.category, l:e.category, e:CAT_EMOJI[e.category]||'🧪'});
      }
    });
    cats.sort(function(a,b){ return a.l.localeCompare(b.l, 'de'); });
    cats.unshift({v:'any', l:'Alle Themen', e:'✨', full:true}); /* „Alle Themen“ ganz oben */
    QS.forEach(function(q){ if(q.dynamic) q.opts = cats; });
  }

  /* Label-Lookup für die Zusammenfassung */
  function optLabel(qid, v) {
    var q = null;
    QS.forEach(function(x){ if(x.id===qid) q = x; });
    if (!q) return v;
    var l = v;
    q.opts.forEach(function(o){ if(o.v===v) l = o.l; });
    return l;
  }

  /* ═══════════════════════════════════════════
     FILTER (mit schrittweiser Lockerung)
     ═══════════════════════════════════════════ */
  var AGE_ORDER = {'Ab 3 Jahren':1,'Ab 5 Jahren':2,'Ab 7 Jahren':3};
  function userAgeGroup(ans) {
    var ageNum = parseInt(ans.age) || 10;
    return ageNum >= 7 ? 3 : ageNum >= 5 ? 2 : 1;
  }
  function isActive(ans, key) {
    if (key === 'time') return !!ans.time && ans.time !== '45+';
    if (key === 'diff') return !!ans.diff && ans.diff !== 'any';
    if (key === 'saison') return !!ans.saison && ans.saison !== 'any';
    if (key === 'category') return !!ans.category && ans.category.length > 0 && ans.category.indexOf('any') === -1;
    return false;
  }

  function doFilter(ans, ignore) {
    ignore = ignore || {};
    var r = EXPERIMENTS.slice();

    if (ans.age) {
      var ua = userAgeGroup(ans);
      r = r.filter(function(e) { return (AGE_ORDER[e.age] || 1) <= ua; });
    }
    if (!ignore.time && isActive(ans,'time')) {
      var t = parseInt(ans.time);
      r = r.filter(function(e) { return e.time <= t; });
    }
    if (!ignore.diff && isActive(ans,'diff')) {
      r = r.filter(function(e) { return e.diff === ans.diff; });
    }
    if (!ignore.category && isActive(ans,'category')) {
      r = r.filter(function(e) { return ans.category.indexOf(e.category) !== -1; });
    }
    if (!ignore.saison && isActive(ans,'saison')) {
      r = r.filter(function(e) { var s = e.saison ? e.saison.split(',') : []; return s.length === 0 || s.indexOf('ganzjährig') !== -1 || s.indexOf(ans.saison) !== -1; });
    }
    return r;
  }

  /* Erst exakt, dann nacheinander Jahreszeit, Schwierigkeit, Zeit, Thema lockern */
  function findResults(ans) {
    var steps = [
      {},
      {saison:1},
      {saison:1, diff:1},
      {saison:1, diff:1, time:1},
      {saison:1, diff:1, time:1, category:1}
    ];
    var names = {saison:'die Jahreszeit', diff:'die Schwierigkeit', time:'den Zeitaufwand', category:'das Thema'};
    for (var i = 0; i < steps.length; i++) {
      var r = doFilter(ans, steps[i]);
      if (r.length > 0) {
        var relaxed = Object.keys(steps[i]).filter(function(k){ return isActive(ans,k); }).map(function(k){ return names[k]; });
        return {list:r, relaxed:relaxed};
      }
    }
    return {list:[], relaxed:[]};
  }

  function joinDE(arr) {
    if (arr.length <= 1) return arr.join('');
    return arr.slice(0, -1).join(', ') + ' und ' + arr[arr.length - 1];
  }

  /* ═══════════════════════════════════════════
     STATE & RENDERING
     ═══════════════════════════════════════════ */
  var step = -1, answers = {};
  var justSubscribed = false; /* nach der Anmeldung: Hinweis zur Bestätigungsmail über den Ergebnissen */
  var subFailed = false;      /* Anmeldung bei Shopify fehlgeschlagen: Hinweis ehrlich anpassen */
  var loggedInEmail = root.getAttribute('data-email') || null;
  /* bekannte E-Mail: eingeloggt oder in diesem Besuch schon angemeldet. Dann fragt eine
     zweite Runde („Nochmal starten“) nicht erneut, sondern speichert nur die neuen Antworten */
  var knownEmail = loggedInEmail;
  var runId = 0; /* zählt Durchgänge, damit eine späte Antwort von Shopify nicht in den nächsten Durchgang greift */
  var speichernNachAnzeige = false, gespeichertRun = -1;

  function R() {
    var h = '<div class="mq-w">' + hdr() + '<div class="mq-c">';
    if (step === -1) h += intro();
    else if (step >= 0 && step < QS.length) h += question(QS[step], step);
    else if (step === QS.length) {
      if (knownEmail) {
        if (loggedInEmail) ga4('Quiz_Abgeschlossen_Eingeloggt');
        step = QS.length + 1;
        h += results();
        speichernNachAnzeige = true;
      } else {
        h += newsletter();
      }
    }
    else if (step === QS.length + 1) h += results();
    h += '</div></div>';
    root.innerHTML = h;
    bind();
    if (speichernNachAnzeige) { speichernNachAnzeige = false; antwortenSpeichern(); }
    if (step > -1) {
      var el = document.getElementById('modolino-quiz-root');
      if (el) { var rect = el.getBoundingClientRect(); if (rect.top < 0) { window.scrollTo({top: window.pageYOffset + rect.top - 30, behavior:'smooth'}); } }
    }
  }

  function hdr() {
    return '<div class="mq-h"><span class="mq-hie" aria-hidden="true">🧪</span><span class="mq-htitle">Forschungs-Check</span></div>';
  }
  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  /* ─── INTRO ─── */
  function intro() {
    var chars = Object.keys(CHAR_EMOJI).map(function(n){ return {e:CHAR_EMOJI[n], n:n}; });
    var ch = '';
    chars.concat(chars).forEach(function(c) {
      var col = gc(c.n);
      ch += '<div class="mq-cp"><div class="mq-ci" style="background:'+col.s2+'">'+c.e+'</div><span class="mq-cn" style="color:'+col.a+'">'+c.n+'</span></div>';
    });
    return '<div class="mq-intro mq-a">' +
      '<h2 class="mq-t">Welches Experiment<br>passt zu deinem Kind?</h2>' +
      '<div class="mq-m"><span><b>⏱️ 1</b>Minute</span><span><b>📋 7</b>Fragen</span><span><b>🔬 100+</b>Experimente</span></div>' +
      '<div class="mq-marquee"><div class="mq-marquee-track">' + ch + '</div></div>' +
      '<button class="mq-bp" data-a="start">Los geht\'s <span class="mq-rk">🚀</span></button>' +
      '</div>';
  }

  /* ─── FRAGE ─── */
  function question(q, idx) {
    var isM = !!q.multi, sel = isM ? (answers[q.id]||[]) : (answers[q.id]||null);
    var can = isM ? sel.length > 0 : !!sel;
    var oh = '';
    q.opts.forEach(function(o) {
      var iS = isM ? sel.indexOf(o.v) !== -1 : sel === o.v;
      var fullClass = o.full ? ' mq-o-full' : '';
      oh += '<button type="button" class="mq-o'+fullClass+(iS?' mq-os':'')+'" data-a="sel" data-v="'+o.v+'" data-q="'+q.id+'" data-m="'+isM+'" aria-pressed="'+iS+'">' +
        '<span class="mq-oe">'+o.e+'</span><span class="mq-ol">'+o.l+'</span></button>';
    });
    var steps = '';
    for (var i = 0; i < QS.length; i++) steps += '<i'+(i<=idx?' class="on"':'')+'></i>';
    var top = '<div class="mq-top">' +
      '<button type="button" class="mq-back" data-a="back" aria-label="Zurück">'+ARROW_L+'</button>' +
      '<div class="mq-steps" role="progressbar" aria-valuemin="1" aria-valuemax="'+QS.length+'" aria-valuenow="'+(idx+1)+'">'+steps+'</div>' +
      '<span class="mq-cnt">'+(idx+1)+'/'+QS.length+'</span></div>';
    /* Weiter geht es immer erst mit dem „Weiter“-Knopf (aktiv, sobald etwas ausgewählt ist) */
    var nav = '<div class="mq-n" id="mq-nav">' +
      '<button type="button" class="mq-bp mq-bp--wide'+(can?'':' mq-bd')+'" id="mq-next" data-a="next" '+(can?'':'disabled')+'>Weiter</button></div>';
    var gridCls = q.cols4 ? ' mq-os-grid--4' : (isM ? ' mq-os-grid--list' : '');
    return '<div class="mq-q mq-a">' + top +
      '<div class="mq-qic" aria-hidden="true">'+(q.ic||'🧪')+'</div>' +
      '<h2 class="mq-qt">'+q.t+'</h2><p class="mq-qs">'+q.s+'</p>' +
      '<div class="mq-os-grid'+gridCls+'" id="mq-grid">'+oh+'</div>'+nav+'</div>';
  }

  /* Auswahl im DOM aktualisieren, ohne die Frage neu zu rendern (kein Flackern) */
  function refreshSelection(qid, isM) {
    var grid = document.getElementById('mq-grid'); if (!grid) return;
    var sel = isM ? (answers[qid]||[]) : (answers[qid]||null);
    grid.querySelectorAll('.mq-o').forEach(function(b) {
      var v = b.getAttribute('data-v');
      var on = isM ? sel.indexOf(v) !== -1 : sel === v;
      b.classList.toggle('mq-os', on);
      b.setAttribute('aria-pressed', on);
    });
    var nb = document.getElementById('mq-next');
    var can = isM ? sel.length > 0 : !!sel;
    if (nb) { nb.classList.toggle('mq-bd', !can); nb.disabled = !can; }
  }

  /* ─── NEWSLETTER ─── */
  function newsletter() {
    return '<div class="mq-nl mq-a">' +
      '<div class="mq-nle" aria-hidden="true">🎉</div><h2 class="mq-qt">Geschafft!</h2>' +
      '<p class="mq-qs">Deine Ergebnisse sind fertig. Möchtest du Tipps, exklusive Angebote und neue Experimente direkt ins Postfach?</p>' +
      '<div class="mq-nlf"><input type="email" id="mq-em" class="mq-in" placeholder="deine@email.de" autocomplete="email" aria-label="E-Mail-Adresse">' +
      '<div id="mq-em-err" class="mq-err">Bitte gib eine gültige E-Mail-Adresse ein.</div>' +
      '<button type="button" class="mq-bp mq-bp--wide mq-bd" id="mq-ns" data-a="sub" disabled>Jetzt anmelden <span class="mq-rk">💌</span></button>' +
      '<p class="mq-privacy">Mit der Anmeldung stimmst du unserer <a href="'+PRIVACY_URL+'" target="_blank" rel="noopener">Datenschutzerklärung</a> zu. Abmeldung jederzeit möglich.</p></div>' +
      '<button type="button" class="mq-sk" data-a="skip"><span>Überspringen und Ergebnisse sofort sehen</span></button></div>';
  }

  /* ─── ZUSAMMENFASSUNG DER ANTWORTEN ─── */
  function summaryChips() {
    var chips = [];
    chips.push({q:'age', t:'👶 ' + (answers.age ? answers.age + ' Jahre' : 'Alter')});
    chips.push({q:'time', t:'⏱️ ' + (answers.time ? optLabel('time', answers.time) : 'Zeit')});
    chips.push({q:'diff', t:'🎯 ' + (answers.diff ? optLabel('diff', answers.diff) : 'Egal')});
    var catText = '✨ Alle Themen';
    if (answers.category && answers.category.length && answers.category.indexOf('any') === -1) {
      catText = answers.category.length === 1
        ? (CAT_EMOJI[answers.category[0]]||'🧪') + ' ' + answers.category[0]
        : '🧪 ' + answers.category.length + ' Themen';
    }
    chips.push({q:'category', t:catText});
    var saisonEmoji = {'frühling':'🌸','sommer':'☀️','herbst':'🍂','winter':'❄️'};
    chips.push({q:'saison', t:(answers.saison && answers.saison !== 'any') ? (saisonEmoji[answers.saison]||'') + ' ' + optLabel('saison', answers.saison) : '📅 Ganzjährig'});
    var h = '<div class="mq-sum">';
    chips.forEach(function(c){ h += '<span class="mq-chip">'+c.t+'</span>'; });
    h += '</div>';
    return h;
  }

  /* ─── ERGEBNISSE ─── */
  function results() {
    var fr = findResults(answers);
    var res = fr.list;

    var h = '<div class="mq-r mq-a"><div class="mq-rh">' +
      '<div class="mq-nle" aria-hidden="true">'+(res.length===0?'🤔':'🔬')+'</div>' +
      '<h2 class="mq-t">' + (res.length===0 ? 'Hmm, keine Treffer!' : res.length + (res.length===1?' Experiment':' Experimente') + ' für dich!') + '</h2>' +
      '<p class="mq-qs">' + (res.length===0 ? 'Für diese Kombination haben wir leider nichts gefunden. Aber schau mal, diese drei könnten dir trotzdem gefallen!' : 'Tippe auf ein Experiment, um direkt zur Anleitung zu kommen.') + '</p>' +
      summaryChips() + '</div>';

    if (justSubscribed) h += subNote();

    if (fr.relaxed.length > 0) {
      h += '<div class="mq-note">💡 Für deine genaue Auswahl gab es keine Treffer. Wir haben deshalb ' + joinDE(fr.relaxed) + ' gelockert.</div>';
    }

    if (res.length === 0) {
      var shuffled = EXPERIMENTS.slice();
      for (var i = shuffled.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
      }
      h += '<div class="mq-slbl">💡 Das könnte dir gefallen</div><div class="mq-cards">';
      shuffled.slice(0, 3).forEach(function(e,i){ h += card(e,i,0); });
      h += '</div>';
    } else {
      /* Top 3: exakte Altersgruppe bevorzugen, dann Bild, Rest zufällig */
      var ua = userAgeGroup(answers);
      var scored = res.map(function(e) {
        var s = ((AGE_ORDER[e.age] || 1) === ua ? 2 : 0) + (e.image ? 1 : 0) + Math.random();
        return {e:e, s:s};
      });
      scored.sort(function(a,b){ return b.s - a.s; });
      var top = scored.slice(0, 3).map(function(x){ return x.e; });
      var topIds = top.map(function(e){ return e.id; });

      h += '<div class="mq-slbl">🌟 Unsere Top-Empfehlungen</div><div class="mq-cards">';
      top.forEach(function(e,i){ h += card(e,i,i+1); }); h += '</div>';

      var grp = {};
      res.forEach(function(e) {
        if (topIds.indexOf(e.id) !== -1) return;
        if (!grp[e.category]) grp[e.category] = [];
        grp[e.category].push(e);
      });
      var cats = Object.keys(grp);
      if (cats.length > 0) {
        cats.forEach(function(cat) {
          var exps = grp[cat];
          h += '<div class="mq-slbl">'+(CAT_EMOJI[cat]||'🧪')+' '+cat+' <b>'+exps.length+'</b></div><div class="mq-cards">';
          exps.forEach(function(e,i){ h += card(e,i,0); }); h += '</div>';
        });
      }
    }

    h += '<button type="button" class="mq-ghost" data-a="restart">🔄 Nochmal starten</button></div>';
    return h;
  }

  function subNote() {
    if (subFailed) return '<div class="mq-note" role="status">⚠️ <b>Die Anmeldung hat gerade nicht geklappt.</b> Deine Ergebnisse siehst du trotzdem hier. Probier die Anmeldung später einfach nochmal.</div>';
    return '<div class="mq-note mq-note--mail" role="status">📬 <b>Fast geschafft!</b> Bitte bestätige deine E-Mail-Adresse über den Link in unserer Mail. Schau auch im Spam-Ordner nach. Bist du schon angemeldet, musst du nichts weiter tun.</div>';
  }

  /* Name fürs Analytics-Ereignis: ohne Emoji am Anfang, höchstens 100 Zeichen (Grenze von Google Analytics) */
  function analyticsName(name) {
    return String(name||'').replace(/^[^A-Za-z0-9ÄÖÜäöüß]+/, '').trim().slice(0, 100).replace(/&/g,'&amp;').replace(/"/g,'&quot;');
  }
  function card(e, i, rank) {
    var c = gc(e.charShort);
    var ds = e.diff==='leicht'?'😊 Leicht':e.diff==='mittel'?'🤔 Mittel':e.diff==='schwer'?'🧠 Schwer':'';
    var thumb = e.image
      ? '<img src="'+e.image+'" alt="" loading="lazy" width="150" height="200">'
      : e.emoji;
    var medal = rank ? '<span class="mq-cdrank" aria-hidden="true">'+(['🥇','🥈','🥉'][rank-1]||rank)+'</span>' : '';
    thumb = '<div class="mq-cdimg'+(e.image?'':' mq-cdimg--e')+'">'+thumb+medal+'</div>';
    return '<a href="'+e.url+'" class="mq-cd'+(rank?' mq-cd--top':'')+'" style="--ca:'+c.a+';--cs1:'+c.s1+';--cs2:'+c.s2+';animation-delay:'+Math.min(i,8)*0.05+'s" data-a="go" data-id="'+e.id+'" data-name="'+analyticsName(e.name)+'">' +
        thumb +
        '<div class="mq-cdi">' +
          '<div class="mq-cdn">'+e.name+'</div>' +
          '<div class="mq-cdc" style="color:'+c.a+'">'+e.emoji+' '+e.charShort+(e.category?' · '+e.category:'')+'</div>' +
          '<div class="mq-cdtags">' +
            '<span class="mq-tg" style="color:'+c.a+';background:'+c.s2+'">⏱ '+(e.timeLabel||e.time+' Min.')+'</span>' +
            (ds?'<span class="mq-tg">'+ds+'</span>':'') +
            (e.age?'<span class="mq-tg">'+e.age+'</span>':'') +
          '</div>' +
        '</div>' +
        '<span class="mq-cdgo" aria-hidden="true">'+ARROW_R+'</span>' +
      '</a>';
  }

  /* ═══════════════════════════════════════════
     GA4 TRACKING
     ═══════════════════════════════════════════ */
  /* Analytics-Ereignisse (Google Analytics über das Pixel „Modolino Ereignisse“): deutsche Namen,
     passend zu den Shopify-Kundenfeldern. Werte sind die Beschriftungen aus dem Quiz, keine Kürzel. */
  var FRAGE_NAME = { gender: 'Kind', age: 'Alter', time: 'Zeit', diff: 'Schwierigkeit', category: 'Themen', saison: 'Jahreszeit', source: 'Quelle' };
  function optionText(qid, v) {
    if (v === undefined || v === null || v === '') return '';
    if (qid === 'age') return String(v);
    var q = null; QS.forEach(function(x){ if(x.id===qid) q = x; });
    var o = null; if (q) q.opts.forEach(function(x){ if(x.v===v) o = x; });
    return String(o ? o.l : v).replace(/\s*&\s*/g, ' und ');
  }
  function antwortenDeutsch() {
    var out = {};
    Object.keys(FRAGE_NAME).forEach(function(qid){ var t = antwortText(qid); if (t) out[FRAGE_NAME[qid]] = t; });
    return out;
  }
  /* Abschluss: alle Antworten, Dauer seit „Los geht's“ in Sekunden, Anzahl gefundener Experimente */
  var startZeit = 0;
  function abschlussDaten() {
    var out = antwortenDeutsch();
    if (startZeit) out.Dauer = Math.round((Date.now() - startZeit) / 1000);
    try { out.Ergebnisse = findResults(answers).list.length; } catch (e) {}
    return out;
  }
  function ga4(event, params) {
    if (typeof window.mdlTrack === 'function') window.mdlTrack(event, params || {});
  }

  /* ═══════════════════════════════════════════
     NAVIGATION
     ═══════════════════════════════════════════ */
  function goNext() {
    if (step < QS.length - 1) step++; else step = QS.length;
    if (step === QS.length) ga4('Quiz_Abgeschlossen', abschlussDaten());
    R();
  }

  /* ═══════════════════════════════════════════
     EVENT BINDING
     ═══════════════════════════════════════════ */
  function bind() {
    root.querySelectorAll('[data-a]').forEach(function(el) {
      el.addEventListener('click', function(ev) {
        var a = this.getAttribute('data-a');
        if (a==='start') {
          startZeit = Date.now(); ga4('Quiz_Start');
          var btn = this; btn.disabled = true;
          loadData().then(function() {
            if (!EXPERIMENTS.length) throw new Error('leer');
            step=0; R();
          }).catch(function() {
            btn.disabled = false;
            root.querySelector('.mq-c').insertAdjacentHTML('beforeend', '<p class="mq-privacy" role="alert">Die Experimente konnten gerade nicht geladen werden. Bitte versuche es gleich noch einmal.</p>');
          });
        }
        else if (a==='sel') {
          var qid=this.getAttribute('data-q'), v=this.getAttribute('data-v'), m=this.getAttribute('data-m')==='true';
          if (m) {
            var arr = answers[qid] || [];
            if (v === 'any') {
              arr = arr.indexOf('any') !== -1 ? [] : ['any'];
            } else {
              arr = arr.filter(function(x){ return x !== 'any'; });
              var idx = arr.indexOf(v);
              if (idx !== -1) arr.splice(idx,1); else arr.push(v);
            }
            answers[qid] = arr;
            ga4('Quiz_Antwort', {Schritt: step + 1, Frage: FRAGE_NAME[qid] || qid, Antwort: optionText(qid, v)});
            refreshSelection(qid, true);
          } else {
            answers[qid] = v;
            ga4('Quiz_Antwort', {Schritt: step + 1, Frage: FRAGE_NAME[qid] || qid, Antwort: optionText(qid, v)});
            refreshSelection(qid, false);
          }
        }
        else if (a==='next') { goNext(); }
        else if (a==='back') { if(step>0)step--;else step=-1; R(); }
        else if (a==='skip'||a==='showres') { ga4('Quiz_Newsletter_Uebersprungen'); step=QS.length+1; R(); }
        else if (a==='restart') { ga4('Quiz_Neustart'); step=-1; answers={}; justSubscribed=false; subFailed=false; runId++; R(); }
        else if (a==='go') { ga4('Quiz_Ergebnis_Klick', {Experiment: this.getAttribute('data-name') || this.getAttribute('data-id')}); }
        else if (a==='sub') { doSub(); }
      });
    });
    var em=document.getElementById('mq-em'), sb=document.getElementById('mq-ns'), errEl=document.getElementById('mq-em-err');
    if(em&&sb){
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      em.addEventListener('input',function(){
        var ok = emailRe.test(em.value);
        sb.classList.toggle('mq-bd',!ok); sb.disabled=!ok;
        if(errEl){
          if(em.value.length > 3 && !ok) { errEl.style.display='block'; em.style.borderColor='#FF805A'; }
          else { errEl.style.display='none'; em.style.borderColor = ok ? '#81BC46' : ''; }
        }
      });
      em.addEventListener('blur',function(){ if(!em.value) em.style.borderColor=''; });
      em.addEventListener('keydown',function(ev){if(ev.key==='Enter'&&!sb.disabled)doSub();});
    }
  }

  /* ═══════════════════════════════════════════
     ANMELDUNG ALS SHOPIFY-KUNDE
     ═══════════════════════════════════════════ */
  /* Antworten als lesbarer Text (z. B. „Mädchen“, „Bis 30 Minuten“), für die Analytics-Ereignisse */
  function antwortText(qid) {
    var v = answers[qid];
    if (v === undefined || v === null || v === '') return '';
    var werte = Array.isArray(v) ? v : [v];
    return werte.map(function(w){ return optionText(qid, w); }).join(', ');
  }

  /* Die Anmeldung legt einen Shopify-Kunden mit Newsletter-Zustimmung an (Double-Opt-in nach
     Shop-Einstellung, Bestätigungsmail kommt von Shopify). Die Antworten reisen als Hilfs-Tags
     „fc-…:Wert“ mit; der Shopify Flow „Forschungs-Check Kundenfelder“ (docs/flow-forschungs-check.md)
     schreibt sie in die Kundenfelder kind.* und forschungs_check.* und entfernt die Hilfs-Tags wieder,
     sodass nur „Forschungs-Check“ bleibt. */
  function fcTags() {
    function sauber(t) { return String(t || '').replace(/,/g, ' ').trim(); }
    var tags = ['Forschungs-Check'];
    function add(name, wert) { wert = sauber(wert); if (wert) tags.push('fc-' + name + ':' + wert); }
    add('kind', optLabel('gender', answers.gender));
    if (answers.age) {
      var alter = parseInt(answers.age, 10); /* „10+“ zählt als 10 */
      add('alter', alter);
      add('geburtsjahr', new Date().getFullYear() - alter);
    }
    add('zeit', optLabel('time', answers.time));
    add('schwierigkeit', optLabel('diff', answers.diff));
    add('jahreszeit', optLabel('saison', answers.saison));
    add('quelle', optLabel('source', answers.source));
    var themen = Array.isArray(answers.category) ? answers.category : (answers.category ? [answers.category] : []);
    if (!themen.length || themen.indexOf('any') !== -1) add('thema', 'Alle Themen');
    else themen.forEach(function(v){ add('thema', optLabel('category', v)); });
    return tags.join(', ');
  }

  /* Shopify verlangt für das Kundenformular meist die Spam-Abfrage. Dann wird das Formular normal
     abgeschickt und die Seite lädt neu (Rückkehr mit ?quiz=angemeldet). Damit die Ergebnisse dabei
     nicht verloren gehen, stehen die Antworten kurz im sessionStorage und werden nach der Rückkehr
     wieder angezeigt. */
  var MARKER = 'quiz=angemeldet';
  var SPEICHER = 'mdlQuizAnmeldung';
  function merken(email, still) {
    try { sessionStorage.setItem(SPEICHER, JSON.stringify({ answers: answers, email: email, still: !!still, zeit: Date.now() })); } catch (e) {}
  }
  function holen() {
    var d = null;
    try { d = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); sessionStorage.removeItem(SPEICHER); } catch (e) {}
    if (!d || !d.answers || Date.now() - (d.zeit || 0) > 30 * 60 * 1000) return null; /* nach 30 Minuten verfallen */
    return d;
  }
  function ergebnisseNachAnmeldung(email, fehlgeschlagen) {
    knownEmail = fehlgeschlagen ? loggedInEmail : email;
    subFailed = !!fehlgeschlagen;
    justSubscribed = true;
    step = QS.length + 1;
    R();
  }

  /* Bekannte E-Mail (eingeloggt oder in diesem Besuch schon angemeldet): Die Ergebnisse erscheinen sofort,
     die Antworten gehen danach über dasselbe Kundenformular an Shopify, damit der Flow die Kundenfelder
     füllt. Unabhängig vom Newsletter-Status; wer noch nicht abonniert ist, bekommt von Shopify die
     Bestätigungsmail. Verlangt Shopify die Spam-Abfrage, lädt die Seite einmal neu und zeigt danach
     wieder die Ergebnisse. Einmal je Durchgang. */
  function antwortenSpeichern() {
    if (!knownEmail || gespeichertRun === runId || typeof window.mdlKundeAnlegen !== 'function') return;
    gespeichertRun = runId;
    merken(knownEmail, true);
    var myRun = runId;
    window.mdlKundeAnlegen(knownEmail, fcTags(), MARKER, { ziel: root.querySelector('.mq-r') || root })
      .then(function(ergebnis) { if (ergebnis === 'ok' && myRun === runId) holen(); })
      .catch(function(err) { holen(); console.warn('Antworten nicht gespeichert:', err && err.message); });
  }

  function doSub() {
    var em=document.getElementById('mq-em');
    if(!em||!em.value)return;
    var email = em.value.trim();
    ga4('Quiz_Newsletter_Anmeldung', {Quelle: optionText('source', answers.source) || 'Unbekannt'});

    if (typeof window.mdlKundeAnlegen !== 'function') { ergebnisseNachAnmeldung(email, true); return; }
    merken(email);
    var sb = document.getElementById('mq-ns');
    if (sb) { sb.disabled = true; sb.classList.add('mq-bd'); sb.innerHTML = 'Einen Moment …'; }
    var myRun = runId;
    /* ziel: dort erscheint bei Bedarf das Captcha-Kästchen, mitten im Quiz statt am Seitenrand */
    window.mdlKundeAnlegen(email, fcTags(), MARKER, { ziel: root.querySelector('.mq-nlf') })
      .then(function(ergebnis) {
        if (myRun !== runId) return;
        /* 'ok': ohne Spam-Abfrage angenommen. 'captcha': die Seite lädt gleich neu */
        if (ergebnis === 'ok') { holen(); ergebnisseNachAnmeldung(email, false); }
      })
      .catch(function(err) {
        if (myRun !== runId) return;
        holen();
        console.warn('Anmeldung bei Shopify fehlgeschlagen:', err && err.message);
        ergebnisseNachAnmeldung(email, true);
      });
  }

  /* Rückkehr nach dem normalen Abschicken: Ergebnisse mit dem Hinweis zur Bestätigungsmail zeigen */
  function rueckkehrNachAnmeldung() {
    if (!window.mdlKundeMarker || !window.mdlKundeMarker(MARKER)) return false;
    var d = holen();
    if (!d) return false;
    answers = d.answers;
    loadData().then(function() {
      if (d.still) {
        knownEmail = d.email; gespeichertRun = runId; step = QS.length + 1; R();
        try { root.scrollIntoView({ block: 'start' }); } catch (e) {}
        return;
      }
      ergebnisseNachAnmeldung(d.email, false);
      try { root.scrollIntoView({ block: 'start' }); } catch (e) {}
    }).catch(function(){});
    return true;
  }

  /* Abbruch: Quiz gestartet, aber vor den Ergebnissen verlassen */
  var abbruchGemeldet = false;
  window.addEventListener('pagehide', function() {
    if (abbruchGemeldet || step < 0 || step >= QS.length) return;
    abbruchGemeldet = true;
    ga4('Quiz_Abbruch', {Schritt: step + 1, Frage: QS[step] ? (FRAGE_NAME[QS[step].id] || QS[step].id) : ''});
  });

  /* INIT */
  R();
  rueckkehrNachAnmeldung();
})();
